export enum AddressUse {
  home = 'HOME',
  work = 'WORK',
  temp = 'TEMP',
}
